import { useDropUp } from '@shared/hooks/useDropUp';

export interface SelectMenuItem {
  key: string;
  label: string;
  onSelect: () => void;
}

interface SelectMenuProps {
  items: SelectMenuItem[];
  widthCls?: string;
}

/**
 * 入力欄の下に開く選択ポップアップ（単位・税率など）。
 * 明細テーブルの overflow 枠で下端が隠れないよう、枠下端までの余白が
 * メニュー高さに満たない場合は上向きに開く（下限値ガード）。
 */
export function SelectMenu({ items, widthCls = 'w-24' }: SelectMenuProps) {
  const { menuRef, dropUp } = useDropUp(true);

  const pos = dropUp ? 'bottom-full mb-1' : 'top-full mt-1';
  return (
    <div
      ref={menuRef}
      className={`absolute ${pos} left-0 z-50 bg-white border border-gray-200 rounded-lg shadow-lg py-1 ${widthCls}`}
    >
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          onClick={it.onSelect}
          className="block w-full text-left px-3 py-1 text-sm hover:bg-blue-50 hover:text-blue-700"
        >
          {it.label}
        </button>
      ))}
    </div>
  );
}
